import { initializeLibrary, isInitialized } from '@grupoprimo/payment-adapter-lib';

class PaymentAdapters {
  constructor() {
    this.initialized = false;
  }

  init() {
    if (this.initialized) {
      return true;
    }

    try {
      initializeLibrary({
        vindiApiKey: process.env.VUE_APP_VINDI_PUBLIC_KEY || '',
        vindiApiTokenUrl: process.env.VUE_APP_VINDI_API_TOKEN_URL || '',
        debug: process.env.VUE_APP_STAGE === 'hml' || false,
        adyenCertificate: process.env.VUE_APP_ADYEN_CERTIFICATE?.replace(/\\n/g, '\n') || '',
      });

      this.initialized = isInitialized();
      return this.initialized;
    } catch (error) {
      throw error;
    }
  }

  isReady() {
    return this.initialized && isInitialized();
  }
}

export default new PaymentAdapters();
